import apiClient from "../../axios/apiClient";

export const getInsuranceMapList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_INSURANCE_MAPPINGLIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/User-Insurance-Mapping`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_INSURANCE_MAPPINGLIST_FULFILLED",
        payload: response.data?.data,
        insuranceMapCount: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_INSURANCE_MAPPINGLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveInsuranceMapData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_INSURANCE_MAPPING_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-User-Insurance-Mapping`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_INSURANCE_MAPPING_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_INSURANCE_MAPPING_REJECTED", payload: error.response });
    }
  };
  

  export const getInsuranceMapListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_INSURANCE_MAPPINGLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/User-Insurance-Mapping/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_INSURANCE_MAPPINGLISTBYID_FULFILLED",
        payload: response.data?.data,
        insuranceMapCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_INSURANCE_MAPPINGLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateInsuranceMapData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_INSURANCE_MAPPING_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-User-Insurance-Mapping/${id}`, // Endpoint URL with Insurance-Mapping ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_INSURANCE_MAPPING_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_INSURANCE_MAPPING_REJECTED", payload: error.response });
  }
};


export const updateInsuranceMapStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_INSURANCE_MAPPING_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-User-Insurance-Mapping-Status/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_INSURANCE_MAPPING_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_INSURANCE_MAPPING_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteInsuranceMapData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_INSURANCE_MAPPING_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-User-Insurance-Mapping/${id}`, // Endpoint URL with Insurance-Mapping ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_INSURANCE_MAPPING_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_INSURANCE_MAPPING_REJECTED", payload: error.response });
  }
};